import { render, staticRenderFns } from "./WfPetImg.vue?vue&type=template&id=42f9e6ae&scoped=true&"
import script from "./WfPetImg.vue?vue&type=script&lang=js&"
export * from "./WfPetImg.vue?vue&type=script&lang=js&"
import style0 from "./WfPetImg.vue?vue&type=style&index=0&id=42f9e6ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f9e6ae",
  null
  
)

export default component.exports